export default __webpack_public_path__ + "static/media/top.d9dffc98.svg";